import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Container,
} from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import ThemeTable from "../../components/Table/ThemeTable";
import AuthContext from "../../hooks/authContext";
import {
  Smartphone,
  Monitor,
  User,
  Building,
  Plus,
  Search,
  FileText,
} from "lucide-react";
import {
  getSupportTickets,
  updateReadStatus,
} from "../../services/apiservices/support";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import moment from "moment";
import styles from "./Accounts.module.scss";
import { Input } from "../../components/ui/input";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import { getAllEmployee } from "../../services/apiservices/employee";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { Badge } from "../../components/ui/badge";

const ManageSupport = () => {
  const auth = useContext(AuthContext);
  const [searchTerm, setsearchTerm] = React.useState("");
  const [supports, setSupports] = useState();
  const [accounts, setAccounts] = useState("All");
  const [types, setTypes] = useState("All");
  const [read, setRead] = useState("All");
  const [status, setStatus] = useState("All");
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const navigate = useNavigate();
  const companyId =
    auth?.userProfile?.role === "superUser"
      ? null
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const statusOptions = [
    { label: "All Statuses", value: "All" },
    { label: "Open", value: "open" },
    { label: "Pending", value: "pending" },
    { label: "Resolved", value: "resolved" },
    { label: "Close", value: "close" },
  ];
  const typeOptions = [
    { label: "All Types", value: "All" },
    { label: "General", value: "general" },
    { label: "Technical", value: "technical" },
  ];
  const readOptions = [
    { label: "All", value: "All" },
    { label: "Read", value: "read" },
    { label: "UnRead", value: "unread" },
  ];
  const accountOptions = [
    { label: "All Accounts", value: "All" },
    { label: "Web", value: "web" },
    { label: "Mobile", value: "mobile" },
  ];
  const Columns = [
    {
      id: "ticket",
      numeric: false,
      disablePadding: true,
      label: "Ticket ID",
      isSortable: true,
      gray: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      label: "Title",
      isSortable: true,
      gray: true,
    },
    // {
    //   id: "company",
    //   numeric: false,
    //   disablePadding: true,
    //   label: "Company",
    //   isSortable: true,
    //   gray: true,
    // },
    // {
    //   id: "user",
    //   numeric: false,
    //   disablePadding: true,
    //   label: "User",
    //   isSortable: true,
    //   gray: true,
    // },
    {
      id: "platform",
      numeric: false,
      disablePadding: true,
      label: "Platform",
      isSortable: true,
      gray: true,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      isSortable: true,
      gray: true,
    },
    {
      id: "created",
      numeric: false,
      disablePadding: true,
      label: "Created",
      isSortable: true,
      gray: true,
    },
    {
      id: "updated",
      numeric: false,
      disablePadding: true,
      label: "Last Update",
      isSortable: true,
      gray: true,
    },
    {
      id: "respondedBy",
      numeric: false,
      disablePadding: true,
      label: "Responded By",
      isSortable: true,
      gray: true,
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "",
      isSortable: true,
      gray: true,
    },
  ];

  const processSupportTickets = (ticketRes, employeeList) => {
    const records = ticketRes?.filter((order) => !Array.isArray(order.readUser) || !order.readUser.includes(auth?.userProfile?.id)) || [];
      if (!Array.isArray(records) || records.length === 0) {
        auth.resetPendingSupportStatus?.();
      }
      if (!ticketRes?.length) {
        setSupports();
        return;
      }
      const tickets = ticketRes?.filter((item) => {
        if (item?.archive !== false) return false;

        if (auth?.userProfile?.role === "Client") {
          return item?.createdBy === auth?.userProfile?.id;
        }
        return true;
      });

      const employeeMap = new Map(
        employeeList?.map((emp) => [
          emp?.id,
          {
            name: `${emp?.firstName} ${emp?.lastName}`,
            email: emp?.email || "",
            role: emp?.role,
          },
        ])
      );

      const enriched = tickets?.map((ticket) => {
        const responses = Object.values(ticket?.responses || {});
        const latestResponse = responses?.reduce(
          (a, b) => (a?.respondOn > b?.respondOn ? a : b),
          {}
        );

        const companyDetails = employeeList?.filter(
          (item) => item?.id === ticket?.companyId
        );
        const companyPlan =
          companyDetails?.subscriptions?.data?.length > 0
            ? companyDetails?.subscriptions?.data?.[0]?.plan?.name
            : "Trial Plan";
        const userName = employeeMap?.get(ticket?.createdBy);
        // const respondedByName = employeeMap?.get(latestResponse?.respondBy);

        return {
          ...ticket,
          title: ticket?.subject,
          ticket: ticket?.ticketNumber,
          platform: ticket?.portal,
          user: userName?.name || "Unknown",
          userEmail: userName?.email,
          updated: ticket?.updatedAt,
          created: ticket?.createdAt,
          respondedBy:
            responses?.length > 0
              ? latestResponse?.respondBy?.name
              : "No Response",
          company: companyPlan,
          role: latestResponse?.respondBy?.role,
        };
      });
      setSupports(sortingFunction(enriched));
  };

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.updatedAt.seconds > b.updatedAt.seconds) return -1;
      if (a.updatedAt.seconds < b.updatedAt.seconds) return 1;

      if (a.ticketNumber > b.ticketNumber) return -1;
      if (a.ticketNumber < b.ticketNumber) return 1;

      return 0;
    });

    return result;
  };

  useEffect(() => {
    let unsubscribe;

    const init = async () => {
      try {
        const [employeeRes] = await Promise.all([
          new Promise((resolve, reject) => getAllEmployee(resolve, reject)),
        ]);
        const employeeList = employeeRes?.data || [];

        unsubscribe = getSupportTickets(
          companyId,
          (ticketRes) => {
            processSupportTickets(ticketRes, employeeList);
          },
          (err) => {
            console.error("subscribeSupportTickets error:", err);
            setSupports([]);
          }
        );
      } catch (error) {
        console.error("Error initializing support tickets subscription:", error);
      }
    };

    init();

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // companyId and processSupportTickets are stable, no need to re-run

  const RedirectToDetails = async (id) => {
    navigate(`/manageSupportDetails/${id}`);
    await updateReadStatus(id);
  };

  // eslint-disable-next-line no-unused-vars
  const TicketStatusBadge = ({ status }) => {
    const getVariant = () => {
      switch (status) {
        case "open":
          return { variant: "default", text: "Open" };
        case "pending":
          return { variant: "warning", text: "Pending" };
        case "resolved":
          return { variant: "success", text: "Resolved" };
        case "close":
          return { variant: "outline", text: "Closed" };
        default:
          return { variant: "default", text: status };
      }
    };

    const { variant, text } = getVariant();

    return (
      <Badge
        variant={variant}
        className="min-w-[80px] text-center justify-center"
        style={{ borderRadius: "4px" }}
      >
        {text}
      </Badge>
    );
  };

  const renderRowCell = (rcellItem, hcellItem, _index, _rowindex) => {
    switch (hcellItem.id) {
      case "ticket":
        const showFlag =
          !rcellItem?.readUser ||
          !rcellItem?.readUser.includes(auth?.userProfile?.id);
        return (
          <div className="d-flex flex-center">
            {showFlag && (
              <FlagOutlinedIcon
                fontSize="small"
                style={{ color: "rgb(59, 130, 246)", marginRight: "5px" }}
              />
            )}
            <span
              style={{ fontSize: "14px", fontWeight: "600" }}
              className="p-8"
            >{`T${rcellItem?.ticketNumber}`}</span>
          </div>
        );

      // case "title":
      //   return (
      //     <div className="p-8">
      //       <div

      //         style={{ fontSize: "14px", }}
      //       >
      //         {rcellItem?.subject}
      //       </div>
      //       <div className="d-flex">
      //         {/* <span
      //           style={{
      //             backgroundColor: "#F3F4F6",
      //             color: "#1F2937",
      //             borderRadius: "40px",
      //           }}
      //           className="mr-5 p-5"
      //         >
      //           {rcellItem?.portal === "web" ? "Portal" : "Mobile"} &nbsp;
      //         </span>
      //         <span
      //           style={{
      //             backgroundColor: "#F3E8FF",
      //             color: "#6B21A8",
      //             borderRadius: "40px",
      //           }}
      //           className="mh-5 p-5"
      //         >
      //           {rcellItem?.type?.charAt(0).toUpperCase() +
      //             rcellItem?.type?.slice(1)}{" "}
      //           &nbsp;
      //         </span> */}
      //         <span className="d-flex flex-center ">
      //           <TextSnippetOutlinedIcon
      //             fontSize="small"

      //           />
      //           <span>
      //             {" "}
      //             {rcellItem?.attachments?.length || 0} file
      //           </span>
      //         </span>
      //       </div>
      //     </div>
      //   );

      case "title":
        return (
          <div className="p-8 ">
            <div className="flex items-center justify-between gap-2">
              <div className="text-sm">{rcellItem?.subject}</div>
              <div className="flex items-center text-sm ">
                <TextSnippetOutlinedIcon fontSize="small" />
                <span>{rcellItem?.attachments?.length || 0} </span>
              </div>
            </div>
          </div>
        );

      case "created":
        const createdAt = rcellItem?.createdAt?.seconds
          ? moment.unix(rcellItem?.createdAt.seconds).format("MM D, YYYY ")
          : "";
        const createdTime = rcellItem?.createdAt?.seconds
          ? moment.unix(rcellItem?.createdAt.seconds).format("h:mm A")
          : "";
        return (
          <div className="flex flex-col">
            <span className="p-1" style={{ fontSize: "14px" }}>
              {createdAt}
            </span>
            <span className="p-1" style={{ fontSize: "14px" }}>
              {createdTime}
            </span>
          </div>
        );
      case "platform":
        return (
          <div className="flex items-center">
            {rcellItem?.portal !== "web" ? (
              <Smartphone className="h-4 w-4 text-gray-500 mr-5" />
            ) : (
              <Monitor className="h-4 w-4 text-gray-500 mr-5" />
            )}
            <span>{rcellItem?.portal === "web" ? "Web" : "Mobile"} &nbsp;</span>
          </div>
        );

      case "status":
        return rcellItem?.status;

      case "updated":
        const updatedAt = rcellItem?.updatedAt?.seconds
          ? moment.unix(rcellItem?.updatedAt.seconds).format("MM D, YYYY")
          : "";
        const updatedTime = rcellItem?.updatedAt?.seconds
          ? moment.unix(rcellItem?.updatedAt.seconds).format("h:mm A")
          : "";
        return (
          <div className="flex flex-col">
            <span className="p-1" style={{ fontSize: "14px" }}>
              {updatedAt}
            </span>
            <span className="p-1" style={{ fontSize: "14px" }}>
              {updatedTime}
            </span>
          </div>
        );
      case "respondedBy":
        return (
          <div
            style={{ color: rcellItem?.role === "superUser" ? "#2563EB" : "" }}
          >
            {rcellItem?.respondedBy}
          </div>
        );

      // case "company":
      //   return (
      //     <div className="flex items-center">
      //       <Building className="h-4 w-4 text-gray-500 mr-5" />
      //       <div>{rcellItem?.company}</div>
      //     </div>
      //   );

      // case "user":
      //   return (
      //     <div className="flex items-center">
      //       <User className="h-4 w-4 text-gray-500 mr-5" />
      //       <span>{rcellItem?.user}</span>
      //     </div>
      //   );

      case "action":
        return (
          <div className="p-8" onClick={() => RedirectToDetails(rcellItem?.id)}>
            <ChevronRightOutlinedIcon />
          </div>
        );

      default:
        return null;
    }
  };

  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.ticketNumber)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.status)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.subject)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList = supports?.filter((item) => {
    const currentUserId = auth?.userprofile?.id;
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;

    const matchesStatus =
      status === "All" || status === "" ? true : item.status === status;

    const matchTypes =
      types === "All" || types === "" ? true : item.type === types;

    const matchAccounts =
      accounts === "All" || accounts === "" ? true : item.portal === accounts;

    const matchReads =
      read === "All"
        ? true
        : read === "read"
        ? Array.isArray(item?.readUser) &&
          item?.readUser?.includes(currentUserId)
        : read === "unread"
        ? !Array.isArray(item.readUser) ||
          !item.readUser.includes(currentUserId)
        : true;

    return (
      matchesSearch &&
      matchesStatus &&
      matchTypes &&
      matchAccounts &&
      matchReads
    );
  });

  const isSuperUser = Array.isArray(auth?.userProfile?.role) ? auth?.userProfile.role.includes("superUser") : auth?.userProfile?.role === "superUser";

  const handleTicketTypeSelect = (option) => {
    navigate("/help/support", {
      state: {
        ticketType: option.value,
      },
    });
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Support Tickets"
           showBreadcrumb={
            isSuperUser ? [{ label: "Home", to: "/superuserdashboard" }, { label: "Help" }] : [{ label: "Home", to: "/" }, { label: "Help" }]
          }
          BreadCrumbCurrentPageTitle={"Support"}
          showLastSeen={true}
          buttonTitle={
            !isSuperUser ? "Create Ticket" : ""
          }
          icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => navigate("/help/support")}
          buttonDropdown={true}
          dropdownOptions={[
            { label: "General Ticket", value: "general" },
            { label: "Technical Ticket", value: "technical" },
          ]}
          onDropdownSelect={handleTicketTypeSelect}
        />
        <div className={isMobile ? "pv-16 ph-6" : "pv-24 ph-32"}>
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column"
                : "d-flex flex-space-between flex-center mb-24"
            }
          >
            <div className={isMobile ? "mb-10" : ""}>
              <h2 className="text-xl font-semibold text-foreground">
                My Tickets
              </h2>
              <p className="text-gray-500 text-sm mt-8">
                View and manage your support tickets
              </p>
            </div>
          </div>
          <Card
            className={`${styles.supportCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
          >
            <CardContent className="pb-24 ph-12">
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column"
                    : "d-flex flex-space-between mb-20"
                }
              >
                <div
                  className="relative flex-1 min-w-[140px]"
                  style={{ maxWidth: isMobile ? "" : "75%" }}
                >
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <Input
                    placeholder="Search tickets..."
                    className="pl-40"
                    id="searchTerm"
                    value={searchTerm}
                    onChange={(e) => setsearchTerm(e.target.value)}
                  />
                </div>
                <div
                  className={
                    isMobile ? "d-flex flex-direction-column" : "d-flex"
                  }
                >
                  <div
                    style={{ width: isMobile ? "390px" : "160px" }}
                    className={isMobile ? "mv-10" : "mh-8"}
                  >
                    <SingleSelectNew
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder={"selectStatus"}
                      value={status}
                      onChange={setStatus}
                      options={statusOptions}
                    />
                  </div>
                  <div
                    style={{ width: isMobile ? "390px" : "160px" }}
                    className={isMobile ? "mv-10" : "mh-8"}
                  >
                    <SingleSelectNew
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder={"selectAccount"}
                      value={accounts}
                      onChange={setAccounts}
                      options={accountOptions}
                    />
                  </div>
                  <div
                    style={{ width: isMobile ? "390px" : "160px" }}
                    className={isMobile ? "mv-10" : "mh-8"}
                  >
                    <SingleSelectNew
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder={"selectType"}
                      value={types}
                      onChange={setTypes}
                      options={typeOptions}
                    />
                  </div>
                  <div
                    style={{ width: isMobile ? "390px" : "160px" }}
                    className={isMobile ? "mv-10" : "mh-8"}
                  >
                    <SingleSelectNew
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder={"selectType"}
                      value={read}
                      onChange={setRead}
                      options={readOptions}
                    />
                  </div>
                </div>
              </div>
              {!isMobile && !isLandscape && (
                <div
                // style={{
                //   border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                //   borderRadius: "6px",
                // }}
                >
                  <ThemeTable
                    rows={filteredList}
                    headCells={Columns}
                    hidePagination={true}
                    renderRowCell={renderRowCell}
                  />
                </div>
              )}
              {(isMobile || isLandscape) &&
                filteredList?.map((item) => {
                  // Status colors available but not used in current implementation
                  // const statusColors = {
                  //   open: "#1573FC",
                  //   closed: "#F1F5F9",
                  //   pending: "#EAB308",
                  //   resolved: "#22C55E",
                  // };
                  // const status = item?.status?.toLowerCase();
                  // const bgColor = statusColors[status] || "#ccc";
                  // const textColor = status === "closed" ? "#000" : "#fff";
                  const updatedAt = item?.updatedAt?.seconds
                    ? moment
                        .unix(item?.updatedAt.seconds)
                        .format("MMM D, YYYY h:mm A")
                    : "";

                  const createdAt = item?.createdAt?.seconds
                    ? moment
                        .unix(item?.createdAt.seconds)
                        .format("MMM D, YYYY h:mm A")
                    : "";
                  const showFlag =
                    !item?.readUser ||
                    !item?.readUser.includes(auth?.userProfile?.id);
                  return (
                    <Card
                      className="mb-10 bg-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                      style={
                        {
                          // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                          // borderRadius: "8px",
                          // boxShadow: "none",
                        }
                      }
                      onClick={() => RedirectToDetails(item?.id)}
                    >
                      <CardContent className="p-16">
                        <div className="">
                          <div className="d-flex flex-space-between">
                            <div className="d-flex">
                              {showFlag && (
                                <FlagOutlinedIcon
                                  fontSize="small"
                                  style={{
                                    color: "rgb(59, 130, 246)",
                                    marginRight: "5px",
                                  }}
                                />
                              )}
                              <div
                                className="mb-5 dark:text-white text-gray-900"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                }}
                              >
                                {item?.subject}
                              </div>
                            </div>
                            <div>
                              <span
                                style={{
                                  // backgroundColor: bgColor,
                                  padding: "2px 10px",
                                  borderRadius: "3px",
                                  // color: textColor,
                                  textTransform: "capitalize",
                                }}
                                className="text-[#6B7280]"
                              >
                                {item?.status}
                              </span>
                            </div>
                          </div>
                          <div className="flex items-center gap-1 text-xs text-gray-600 mb-1">
                            {item?.web === "mobile" ? (
                              <Smartphone className="h-3 w-3 mr-1 text-gray-500" />
                            ) : (
                              <Monitor className="h-3 w-3 mr-1 text-gray-500" />
                            )}
                            <span>
                              {" "}
                              {item?.portal === "web"
                                ? "Web"
                                : "Mobile"}
                            </span>
                          </div>

                          <div className="flex flex-wrap items-center gap-2 mb-5 text-xs text-gray-600">
                            <div className="flex items-center">
                              <User className="h-3 w-3 mr-1" />
                              <span>{item?.user || "Unknown User"}</span>
                            </div>
                            <span>•</span>
                            <div className="flex items-center">
                              <Building className="h-3 w-3 mr-1" />
                              <span>{item?.company || "Unknown Company"}</span>
                            </div>
                          </div>
                          <div className="flex flex-wrap items-center gap-1 mb-5">
                            {/* <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-800">
                              {item?.portal === "web" ? "Portal" : "Mobile"}
                            </span> */}
                            <span className="text-xs px-2 py-0.5 rounded-full bg-purple-100 text-purple-800">
                              {item?.type === "technical"
                                ? "Technical"
                                : "General"}
                            </span>
                            {item?.attachments &&
                              item?.attachments.length > 0 && (
                                <span className="text-gray-500 text-xs flex items-center">
                                  <FileText className="h-3 w-3 mr-4" />
                                  {item?.attachments.length}{" "}
                                  {/* {item?.attachments.length === 1
                                    ? "file"
                                    : "files"} */}
                                </span>
                              )}
                          </div>
                          <div className="text-xs mb-4">
                            <span className="text-gray-500">
                              Responded by: {" "}
                            </span>
                            <span
                              className={`${
                                item?.role === "superUser"
                                  ? "text-blue-600 font-medium"
                                  : "dark:text-white"
                              }`}
                            >
                              {item?.respondedBy}
                            </span>
                          </div>
                          <div className="d-flex flex-space-between mt-8">
                            <div style={{ fontSize: "12px", color: "#6B7280" }}>
                              Created: {createdAt}
                            </div>
                            <div style={{ fontSize: "12px", color: "#6B7280" }}>
                              Last: {updatedAt}
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
            </CardContent>
          </Card>
        </div>
      </Container>
    </>
  );
};

export default ManageSupport;
